import {NotificationNumberResolver} from "./notification.resolver";
import {NgModule} from "@angular/core";
import {RappelLaboComponent} from "./pages/laboratoire/rappelLabo/rappelLabo.component";
import {LaboratoireComponent} from "./pages/laboratoire/laboratoire.component";
import {RappelComponent} from "./pages/patient/rappel/rappel.component";
import {ModePaiementComponent} from "./pages/mode-paiement/mode-paiement.component";
import {RecapPaiementComponent} from "./pages/recap-paiement/recap-paiement.component";

import {BackComponent} from "./pages/back.component";
import {PaiementStore} from "./pages/paiement.store";
import {PaiementResolver} from "./pages/paiement.resolver";

import {PatientComponent} from "./pages/patient/patient.component";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";

import {LogoutAuthGuard} from "@digicerba/common";
import {IPaiementWebServiceClient} from "@resources/resources";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {UserResolver} from "./user.resolver";

const cerbaRoutes: Routes = [
    {
        path: 'cerba',
        component: CerbaPageComponent,
        resolve: {
          user: UserResolver,
          nbAlerts: NotificationNumberResolver,
        },
        children: [
            {
                path: 'mode-paiement',
                component: ModePaiementComponent
            },
            {
                path: 'paiement-patient',
                component: PatientComponent,
              resolve: {
                paiements: PaiementResolver
              }
            },
          {
            path: 'paiement-patient/:paiementKey',
            component: BackComponent
            },
            {
                path: 'paiement-laboratoire',
                component: LaboratoireComponent,
              resolve: {
                paiements: PaiementResolver
              }
            },
          {
            path: 'paiement-laboratoire/:paiementKey',
            component: BackComponent,
            },
            {
                path: 'recap-paiement',
                component: RecapPaiementComponent
            },
            {
                path: '', redirectTo: 'mode-paiement', pathMatch: 'full'
            }]
    },
    { path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard] },

    { path: '', redirectTo: 'cerba', pathMatch: 'full' }
];

@NgModule({
    declarations: [
        HeaderComponent,
        CerbaPageComponent,
        ModePaiementComponent,
        PatientComponent,
        RecapPaiementComponent,
        RappelComponent,
        LaboratoireComponent,
      RappelLaboComponent,
      BackComponent
    ],
    imports: [
        CerbaCommonModule,
        RouterModule.forRoot(cerbaRoutes, { useHash: true }),
    ],
    exports: [
        RouterModule
    ],
    providers: [
      UserResolver, IPaiementWebServiceClient, NotificationNumberResolver,
      PaiementStore, PaiementResolver
    ]

})
export class CerbaRoutingModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts